// removed by extract-text-webpack-plugin
module.exports = {"siblings":"_24lW","item":"_2r5W","arrow":"Yjnd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/simplelist/style.css
// module id = 414
// module chunks = 9